import { useCallback, useEffect, useState } from 'react';
import layout from '~/const/layout';
import { ThemeType } from '~/model/GlobalTypes';
import { getCookie, getUserPreferedColorScheme } from '~/utils/utils';

export const THEME_CHANGE_EVENT = 'theme-change';

type EffectiveThemeType = ThemeType.light | ThemeType.dark;

const resolveSelectedTheme = (themeCookie?: string): ThemeType => {
  if (themeCookie === ThemeType.light || themeCookie === ThemeType.dark || themeCookie === ThemeType.system)
    return themeCookie;
  return ThemeType.system;
};

const resolveEffectiveTheme = (selectedTheme: ThemeType): EffectiveThemeType => {
  if (selectedTheme === ThemeType.light || selectedTheme === ThemeType.dark)
    return selectedTheme;
  const systemTheme = getUserPreferedColorScheme();
  return systemTheme === ThemeType.dark ? ThemeType.dark : ThemeType.light;
};

const getThemeState = () => {
  const selectedTheme = resolveSelectedTheme(getCookie('theme'));
  const activeThemeMode = resolveEffectiveTheme(selectedTheme);

  return {
    activeThemeMode,
    selectedTheme,
  };
};

export const useActiveThemeMode = () => {
  const [themeState, setThemeState] = useState(getThemeState);

  const syncThemeState = useCallback(() => {
    setThemeState(getThemeState());
  }, []);

  useEffect(() => {
    syncThemeState();

    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      const mql = window.matchMedia(layout.matchMedia.dark);
      mql.addEventListener('change', syncThemeState);
    }
    window.addEventListener(THEME_CHANGE_EVENT, syncThemeState);

    return () => {
      if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
        const mql = window.matchMedia(layout.matchMedia.dark);
        mql.removeEventListener('change', syncThemeState);
      }
      window.removeEventListener(THEME_CHANGE_EVENT, syncThemeState);
    };
  }, [syncThemeState]);

  return themeState;
};
